// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2XIyQ","signatureBlock":"Footer_signatureBlock__3Cpd9","signature":"Footer_signature__1VXkB"};